"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwitterCardHead = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_helmet_1 = require("react-helmet");
/**
 * // https://developer.twitter.com/en/docs/twitter-for-websites/cards/overview/markup
 */
function TwitterCardHead({ title, description, image }) {
    return ((0, jsx_runtime_1.jsxs)(react_helmet_1.Helmet, { children: [(0, jsx_runtime_1.jsx)("meta", { property: "twitter:card", content: "summary_large_image" }), (0, jsx_runtime_1.jsx)("meta", { property: "twitter:site", content: "@Snapchat" }), (0, jsx_runtime_1.jsx)("meta", { property: "twitter:title", content: title }), (0, jsx_runtime_1.jsx)("meta", { property: "twitter:image", content: image.url }), description && (0, jsx_runtime_1.jsx)("meta", { property: "twitter:description", content: description })] }));
}
exports.TwitterCardHead = TwitterCardHead;
//# sourceMappingURL=TwitterCardHead.js.map